import React from 'react';
import Loader from './Loader';

interface LoadingOverlayProps {
  loading: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="absolute w-full h-full bg-white/75 left-0 z-50">
      <Loader position={'absolute'} />
    </div>
  );
};

export default LoadingOverlay;
